import { signInWithEmailAndPassword, signOut, User, UserCredential } from "firebase/auth";
import { auth } from "../Database/Firebase.service";
import Cookies from "js-cookie";


export const AuthenticateUser = async (email: string, password: string): Promise<User | Error> => {
    try {
        const userCredential: UserCredential = await signInWithEmailAndPassword(auth, email, password);
        const loggedUser: User = userCredential.user;

        if(!loggedUser){
            throw new Error('Credenciais de acesso invalidas.');
        }

        const userToken = await loggedUser.getIdToken();
        if(userToken){
            Cookies.set('authtoken',userToken, {
                expires: 7,
                sameSite: "Lax",
                secure: true
            });
        }

        return loggedUser;
    } catch (error) {
        console.error(error);
        return (error as Error);
    }
}

export const DisconnectUser = async (navigate: (path: string) => void) => {
    try {
        await signOut(auth); // Faz logout no Firebase
        Cookies.remove('authtoken'); // Remove o token do cookie
        navigate('/login'); // Redireciona para a página de login
    } catch (error) {
        console.error('Erro ao desconectar o usuário:', error);
    }
}